import React, { memo, useCallback, useEffect, useMemo } from "react";
import { combineProps, deepClone } from "../../../../helpers/objectHelper";
import { ScrollWrapper } from "../../../helpers/module.helper";
import { ChatAvatar } from "./ChatAvatar";
import { MessageBubble } from "./MessageBubble";
import { NoMessagePlaceholder } from "./NoMessagePlaceholder";
import { ScrollToBottomButton } from "./ScrollToBottomButton";
import PersonRoundedIcon from "@material-ui/icons/PersonRounded";
import { formatTime, isTheSameMinute } from "../../../../helpers/time.helper";
import AccessTimeIcon from "@material-ui/icons/AccessTime";
import { TimeStamp } from "./shared/TimeStamp";

const MOCK_MESSAGES = [
  {
    interactionChatId: 1,
    eventId: 1,
    sender: "123123",
    receiver: "ALL",
    message: "Hej!",
    inserted: "2021-01-22T14:57:09.2580406",
    senderOrderId: 100000,
    senderFirstName: "Pelle",
    senderLastName: "Persson",
    senderCompanyName: "Pelles bolag",
    receiverOrderId: null,
    receiverFirstName: null,
    receiverLastName: null,
    receiverCompanyName: null,
    receiverExhibitorId: null,
    senderExhibitorId: null,
    likes: null,
    seen: true,
    room: null,
    fromYou: true,
  },
  {
    interactionChatId: 2,
    eventId: 1,
    sender: "123123",
    receiver: "ALL",
    message: "Hej Kent! Kul att se ditt namn här!",
    inserted: "2021-01-22T14:57:09.2580406",
    senderOrderId: 100000,
    senderFirstName: "Pelle",
    senderLastName: "Persson",
    senderCompanyName: "Bolaget BA",
    receiverOrderId: null,
    receiverFirstName: null,
    receiverLastName: null,
    receiverCompanyName: null,
    receiverExhibitorId: null,
    senderExhibitorId: null,
    likes: null,
    seen: true,
    room: null,
    fromYou: false,
  },
];

//Messagelist should only update if new messages is recivied or connectionList has changed
const areEqual = (prevProps, nextProps) => {
  let equal = true;
  if (prevProps.connectionList !== nextProps.connectionList) {
    equal = false;
  }
  if (prevProps.chats !== nextProps.chats) {
    equal = false;
  }
  if (prevProps.currentChat !== nextProps.currentChat) {
    equal = false;
  }
  if (
    nextProps.chatTemplate &&
    prevProps.chatTemplate &&
    (prevProps.chatTemplate.primaryColor !== nextProps.chatTemplate.primaryColor ||
      prevProps.chatTemplate.secondaryColor !== nextProps.chatTemplate.secondaryColor ||
      prevProps.chatTemplate.messages !== nextProps.chatTemplate.messages)
  ) {
    equal = false;
  }
  if (nextProps.initalScrollPos !== prevProps.initalScrollPos) {
    equal = false;
  }

  return equal;
};

export const MessageList = memo((props) => {
  const {
    onScroll,
    chatTemplate,
    chats,
    clientKey,
    currentChat,
    backstage,
    template,
    scrollRef,
    likeMessage = () => null,
    connectionList,
    lang,
    messagesToShow,
    lastMessageRef,
    settings,
    orderList,
    preview,
    tickCode
  } = props;
  const { messages } = chatTemplate;

  const getMessages = useCallback(() => {
    if (preview) return MOCK_MESSAGES;
    const requestedChat = chats.find((c) => c.target == currentChat);
    if (!currentChat || !requestedChat) return [];
    return requestedChat.messages; /* .slice(messagesToShow * -1); */
  }, [chats, currentChat, messagesToShow]);

  const chatMessages = getMessages()?.filter((m) => {
    if(settings.hideMessages){
      return m.message.hidden != true;
    }
    return true;
  });
  const { showUserProfileImage } = settings;


  const scrollWrapperProps = {
    template,
    backstage,
  };
  return (
    <ScrollWrapper {...scrollWrapperProps}>
      <div
        className="conversation jir-scroll"
        style={{
          background: chatTemplate.content.background.toString().includes("http") ? `url(${chatTemplate.content.background})` : chatTemplate.content.background,
          backgroundSize: "cover",
          backgroundPosition: "50% 50%",
          backgroundRepeat: "no-repeat",
          overflowY: "auto",
        }}
        ref={scrollRef}
        onScroll={() => onScroll(true)}
      >
        {((chats.length > 0 && currentChat) || preview) && chatMessages.length > 0 ? (
          chatMessages
            .filter((m) => !m.message.includes("JX_ADMIN_REMOVED") && m?.hidden !== true)
            .map((m, i) => {
              const length = chatMessages.filter((m) => !m.message.includes("JX_ADMIN_REMOVED")).length;
              return (
                <div key={m.interactionChatId} ref={i == length - 1 ? lastMessageRef : undefined}>
                  {i != 0 && !isTheSameMinute(m.inserted, chatMessages[i - 1].inserted) ? (
                    <TimeStamp
                      {...combineProps([
                        {
                          messages,
                          timeStamp: m.inserted,
                          lang,
                        },
                      ])}
                    />
                  ) : null}
                  <div
                    className="c-box-da"
                    style={{
                      padding: !showUserProfileImage ? "0px" : "0px 15px",
                      flexDirection: m.sender == clientKey || (preview && m.fromYou) ? "row-reverse" : undefined,
                    }}
                  >
                    {showUserProfileImage ? (
                      <div className="chat-avatar-wrapper">
                        <ChatAvatar
                          clientKey={clientKey}
                          primaryColor={chatTemplate.primaryColor}
                          secondaryColor={chatTemplate.secondaryColor}
                          orderList={orderList}
                          connectionList={connectionList}
                          target={m.sender}
                        >
                          <PersonRoundedIcon />
                        </ChatAvatar>
                      </div>
                    ) : null}
                    <MessageBubble
                      {...combineProps([
                        { ...m, timeStamp: m.inserted,  },
                        {
                          chatTemplate,
                          orderList: props.orderList,
                          likeMessage: likeMessage,
                          fromYou: m.sender == clientKey || (preview && m.fromYou),
                          tickCode
                        },
                      ])}
                    />
                  </div>
                </div>
              );
            })
        ) : (
          <NoMessagePlaceholder />
        )}
      </div>
    </ScrollWrapper>
  );
}, areEqual);
